<template>
  <div class="order-totals-row" :class="`order-totals-row--${variant}`">
    <div class="order-totals-row__text">{{ label }}</div>
    <transition name="toggle-fade">
      <div v-show="isValueVisible" class="order-totals-row__amount">{{ value }}</div>
    </transition>
  </div>
</template>

<script>
export const VARIANTS = {
  default: 'default',
  bold: 'bold',
}

export default {
  name: 'OrderTotalsRow',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: { type: [String, Number], required: true },
    variant: {
      type: String,
      default: VARIANTS.default,
      validator(value) {
        return Object.values(VARIANTS).includes(value)
      },
    },
    isValueVisible: { type: Boolean, default: true },
  },
}
</script>
<style scoped lang="scss">
.order-totals-row {
  display: flex;
  justify-content: space-between;
  color: $color-grey-mid-3;
  font-size: $font-size-small;
  line-height: space(8, $font-size-small);

  &--bold {
    font-weight: bold;
    color: $color-grey-dark-3;
    font-size: $font-size-normal;
    line-height: space(6);
    letter-spacing: $font-spacing-small;

    border-top: 1px solid $color-grey-light-5;
    margin: space(4) 0 space(5);
    padding-top: space(4);
  }
}
</style>
